<template>
  <v-card>
    <v-icon v-on:click.stop="$emit('close')" large class="closeIcon mt-3 mx-2"
      >mdi-close</v-icon
    >

    <v-card-title class="text-h5"> Gérer mes notifications </v-card-title>

    <v-form class="mb-2 px-3 py-3">
      <div class="text-left">
        <v-icon class="mr-2">mdi-bell</v-icon>
        <v-label
          >Sélectionnez les matières pour lesquelles vous souhaitez recevoir des
          notifications</v-label
        >
      </div>

      <div class="mt-3 mb-2">
        <v-btn
          small
          outlined
          color="primary"
          class="mr-2"
          @click="selectAll"
          :disabled="materials.length === 0"
        >
          <v-icon small class="mr-1">mdi-checkbox-multiple-marked</v-icon>
          Tout sélectionner
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          @click="deselectAll"
          :disabled="materials.length === 0"
        >
          <v-icon small class="mr-1"
            >mdi-checkbox-multiple-blank-outline</v-icon
          >
          Tout désélectionner
        </v-btn>
      </div>

      <div class="text-center mt-2">
        <v-chip color="primary" outlined>
          <v-icon small class="mr-1">mdi-counter</v-icon>
          {{ selectedCount }} / {{ materials.length }} matière{{
            materials.length > 1 ? "s" : ""
          }}
          sélectionnée{{ selectedCount > 1 ? "s" : "" }}
        </v-chip>
      </div>

      <v-sheet
        class="mt-4 pa-3"
        outlined
        style="max-height: 50vh; overflow-y: auto"
      >
        <div v-if="materials.length === 0" class="text-center py-4">
          <v-progress-circular indeterminate></v-progress-circular>
          <p class="mt-2">Chargement des matières...</p>
        </div>

        <div v-else>
          <v-checkbox
            v-for="material in materials"
            :key="material._id"
            v-model="selectedMaterials"
            :label="material.name"
            :value="material._id"
            class="my-2"
          ></v-checkbox>
        </div>
      </v-sheet>

      <ValidateErrorButtons
        @successClicked="validate()"
        @errorClicked="$emit('close')"
        class="mt-4"
      >
        <template v-slot:error>ANNULER</template>
        <template v-slot:success>VALIDER</template>
      </ValidateErrorButtons>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ValidateErrorButtons from "./ValidateErrorButtons.vue";

export default {
  name: "DialogNotifications",
  components: {
    ValidateErrorButtons,
  },
  props: {
    user: Object,
  },
  data: () => ({
    selectedMaterials: [],
    materials: [],
  }),
  computed: {
    ...mapGetters({
      currentUser: "user/getUser",
      allMaterials: "materials/getMaterials",
    }),
    selectedCount() {
      return this.selectedMaterials.length;
    },
  },
  methods: {
    selectAll: function () {
      this.selectedMaterials = this.materials.map((material) => material._id);
    },
    deselectAll: function () {
      this.selectedMaterials = [];
    },
    validate: function () {
      let payload = {
        _id: this.user._id,
        notification_materials: this.selectedMaterials,
      };

      this.$store
        .dispatch("user/updateUserNotifications", payload)
        .then(() => {
          const topEndMessage = {
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal?.stopTimer);
              toast.addEventListener("mouseleave", this.$swal?.resumeTimer);
            },
          };

          this.$swal.mixin(topEndMessage).fire({
            icon: "success",
            title: "Vos préférences de notification ont été mises à jour !",
          });

          this.$emit("close");
        })
        .catch((err) => {
          console.error(err);
          this.$swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Une erreur est survenue lors de la mise à jour de vos préférences",
          });
        });
    },
  },
  mounted() {
    this.$store.dispatch("materials/materials").then(() => {
      this.materials = this.allMaterials.filter((material) => {
        return (
          material.school === this.user.school &&
          material.year === this.user.year &&
          !material.is_deleted &&
          material.is_displayed
        );
      });
      if (
        this.user.notifiedMaterials &&
        this.user.notifiedMaterials.length > 0
      ) {
        this.selectedMaterials = this.user.notifiedMaterials.map((material) => {
          return typeof material === "object" ? material._id : material;
        });
      }
    });
  },
};
</script>

<style scoped>
.closeIcon {
  cursor: pointer;
  float: right;
}
</style>
